import React from 'react'

export const NewReactRewrite: React.FC = () => {
  return (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <pre style={{ color: 'red', fontSize: '1.5rem' }}>TODO: Add content</pre>
    </div>
  )
}
